import { render, staticRenderFns } from "./DocsStorage.vue?vue&type=template&id=33876e98&scoped=true"
import script from "./DocsStorage.vue?vue&type=script&lang=js"
export * from "./DocsStorage.vue?vue&type=script&lang=js"
import style0 from "./DocsStorage.vue?vue&type=style&index=0&id=33876e98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33876e98",
  null
  
)

export default component.exports